// extracted by mini-css-extract-plugin
export default {"banner":"wMpWy0K8 ZPndn63a","hideButton":"A36AZBrK o3oKAnUN"};